import { Link } from "react-scroll";
import { useState, useEffect } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/solid";
import logo from "../assets/images/logo.png";

export const Header = () => {
    const [activeLink, setActiveLink] = useState("home");
    const [scrolling, setScrolling] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    const handleClick = (sectionId) => {
        setActiveLink(sectionId);
        setMenuOpen(false);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const sections = ["home", "about Us", "solutions", "references", "contact"];

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setActiveLink(entry.target.id);
                }
            });
        }, {
            threshold: 0.5,
        });

        sections.forEach((sectionId) => {
            const section = document.getElementById(sectionId);
            if (section) {
                observer.observe(section);
            }
        });

        return () => {
            sections.forEach((sectionId) => {
                const section = document.getElementById(sectionId);
                if (section) {
                    observer.unobserve(section);
                }
            });
        };
    }, []);

    return (
        <div className={`fixed top-0 w-full transition-all ${scrolling ? "bg-[#F5F5F5]" : "bg-transparent"}`} style={{ zIndex: 999 }}>
            <div className="w-full lg:max-w-7xl mx-auto flex justify-between items-center py-3 px-4">
                <a href="#home" className="cursor-pointer w-3/12 justify-start mr-10">
                    <img src={logo} alt="Arkenom" className="w-[135px]" />
                </a>
                <div className="lg:hidden flex items-center">
                    <button onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <XMarkIcon className="h-8 w-8 text-black/70" /> : <Bars3Icon className="h-8 w-8 text-black/70" />}
                    </button>
                </div>
                <nav className={`lg:flex gap-2 w-full ${menuOpen ? "flex flex-col absolute top-full left-0 w-full bg-[#e8e8e8] p-4" : "hidden"} lg:relative lg:w-full lg:flex-row lg:ml-16 lg:bg-transparent`}>
                    {['home', 'about Us', 'solutions', 'references'].map((section) => (
                        <Link
                            key={section}
                            to={section}
                            spy={true}
                            smooth={true}
                            duration={1200}
                            offset={-70}
                            onClick={() => handleClick(section)}
                            className={`nav-item cursor-pointer text-sm md:text-base ${activeLink === section ? "bg-gray-900 text-white" : ""}`}
                        >
                            {section.charAt(0).toUpperCase() + section.slice(1)}
                        </Link>
                    ))}
                </nav>
                <div className="hidden lg:flex w-3/6 justify-end gap-4">
                    <Link 
                        to="contact"
                        spy={true}
                        smooth={true}
                        duration={1200}
                        offset={-70}
                        onClick={() => handleClick("contact")}
                        className="px-10 py-2 rounded-full text-white bg-gradient-to-r from-black/50 to-black/70 border border-black/10 font-medium backdrop-blur-sm hover:bg-black/60 transition-all duration-300 cursor-pointer"
                    >
                        Contact Us
                    </Link>
                </div>
            </div>
        </div>
    );
};
